import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers';
import Loader from './loader/LoaderFullScreen';
import { useAuthQueryParams, useQuery } from '../../hooks/urlHooks';
import { safeNavigateToUrl } from '../../lib/navigationUtils';

const DefaultRoute = () => {
  const queryString = useAuthQueryParams();
  const { redirectUrl } = useQuery();
  const navigate = useNavigate();

  const { team } = useSelector((state: RootState) => state) || {};
  const { teamId } = team.selectedTeam || {};

  useEffect(() => {
    // If there's a redirectUrl, navigate there after login
    if (teamId && redirectUrl) {
      safeNavigateToUrl(redirectUrl, navigate);
    }
  }, [teamId, redirectUrl, navigate]);

  if (!teamId) return <Loader />;

  // If redirectUrl exists, the useEffect will handle the navigation
  // Show loader while redirecting
  if (redirectUrl) {
    return <Loader />;
  }

  return <Navigate to={`/library/${teamId}/recents${queryString}`} />;
};

export default DefaultRoute;
